export default __webpack_public_path__ + "static/media/healthcare_transport.3d886336.png";